// Declaração de variável global do WebApp
declare const exitWebApp: any;

import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { filter, take } from "rxjs/operators";
import {
    Component,
    ElementRef,
    ViewChild,
    Renderer2,
    OnInit,
    Input,
    ViewEncapsulation,
} from "@angular/core";

import { AppState } from "../../interfaces/app-state.interface";
import { getProfileDisplayName } from "../../resources/profile.utils";
import { UsersAction } from "./../../state-management/users/users.actions";
import { LayerService } from "./../../services/LayerService";
import { DialogsService } from "../../services/dialogs.service";
import { SettingsService } from "../../services/settings/settings.service";
import { TrackingActions } from "./../../state-management/tracking/tracking.action";
import { TrackOriginEnum } from "../../enum/segment/segment-origin.enum";
import { LoginWraperService } from "./../../services/login.wraper.service";
import { TrSideMenuComponent } from "../../components/tr-side-menu/tr-side-menu.component";
import {
    FormsEventType,
    FormsEvents,
} from "../../enum/tracking/forms-events.enum";
import { HubBaseRegistrationComponent } from "../hub-base-registration/hub-base-registration.component";
import { ActionEventsEnum } from "../../enum/tracking/action-events.enum";
import { SuitabilitySantanderAction } from "../../state-management/suitability-santander/suitability-santander.action";
import { environment } from '../../../src/environments/environment'

@Component({
    selector: "hub-nav",
    templateUrl: "./hub-nav.component.html",
    styleUrls: ["./hub-nav.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class HubNavComponent implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    @ViewChild("navbar", { static: true })
    public navBar: ElementRef;

    @Input()
    public link: string = "";

    @Input()
    public hideLinks: boolean = false;

    @Input()
    public hideBurgerMenu: boolean = false;

    @Input()
    public logoPath: string = `/assets/images/${ environment.isNewBrand ? "santander" : "toro" }-red-black-small.svg`;

    @Input()
    public logoDarkPath: string = `/assets/images/${ environment.isNewBrand ? "santander" : "toro" }-total-white.svg`;

    @Input()
    public bgColorClass: "darker" | "transparent" | "opacity" | "default" =
        "default";

    @Input()
    public externalRouter: boolean = false;

    @Input()
    public productAreaOrigin: string;

    @Input()
    public status: string;

    @Input()
    public scenario: string;

    @Input()
    public risesButNotGoDown: boolean = false;

    public element: HTMLElement;
    public didScroll: boolean;
    public lastScroll: number = 0;
    public currentUser: any;
    public navbarHeight: number = 0;
    public registerAppUrl: string;
    public notificationsMenuOpen: Event;
    public hubUrl: string;
    public aprendaUrl: string;
    public siteUrl: string;
    public displayName: string;

    constructor(
        public layerService: LayerService,
        private store: Store<AppState>,
        private router: Router,
        private render: Renderer2,
        private dialogsService: DialogsService,
        private settingsService: SettingsService,
        private loginWraperService: LoginWraperService
    ) {
       this.store.dispatch({ type: SuitabilitySantanderAction.getProfileSantander });
       this.store.dispatch({ type: SuitabilitySantanderAction.checkClientExcludeFromCommunication });

        this.hubUrl = settingsService.getConfigurationKeyValue("hubUrl");
        this.siteUrl = settingsService.getConfigurationKeyValue("siteUrl");
        this.aprendaUrl = `${this.siteUrl}/aprenda`;

        this.registerAppUrl =
            this.settingsService.getConfigurationKeyValue("rau");
    }

    public get hasPreviousSession() {
        return !!this.currentUser && !!this.currentUser.token;
    }

    public ngOnInit() {
        this.element = document.documentElement;
        this.navbarHeight = this.navBar.nativeElement.offsetHeight * 3;

        this.store
            .select((state) => state.authentication)
            .pipe(
                filter(({ currentUser }) => !!currentUser),
                take(1)
            )
            .subscribe(({ currentUser }) => {
                this.currentUser = currentUser;
                this.displayName = currentUser && currentUser.name;
            });

        this.store
            .select((state) => state.userProfile.user)
            .pipe(filter((user) => !!user))
            .subscribe((user: any) => {
                this.displayName = getProfileDisplayName(user) || (this.currentUser && this.currentUser.name);
            });

        setInterval(() => {
            if (this.didScroll) {
                this.hasScrolled();
                this.didScroll = false;
            }
        }, 250);

        window.addEventListener("scroll", () => (this.didScroll = true));
    }

    /**
     * Retorna se há um cliente logado
     *
     */
    public get hasLoggedUser() {
        return !!this.currentUser;
    }

    /**
     * Eventos de notificação
     */
    public onNotificationsMenuOpen($event: Event) {
        this.notificationsMenuOpen = $event;

        if (this.isMobile) {
            this.render[event ? "addClass" : "removeClass"](
                this.navBar.nativeElement,
                "menu-open--mobile"
            );
        }
    }

    /**
     * Abre a gaveta de login
     */
    public showLoginPanel() {
        const snapshot = `${window.location.pathname}${window.location.search}`;

        this.loginWraperService.navigateToLogin({
            afterLoginRedirectTo: snapshot,
        });
    }

    /**
     * Realiza logout do cliente
     */
    public logout() {
        this.store.dispatch({ type: UsersAction.logout });

        // Função do ambiente do WebApp
        if (typeof exitWebApp === "function") exitWebApp();
    }

    public openOverlay = (overlayId: string) =>
        this.layerService.overlay(overlayId);
    public onOverlayLinksClick = () => this.layerService.destroyAllOverlays();

    /**
     * Dispara Element Clicked (Mixpanel) para os links de navegação do header.
     * Só dispara quando productAreaOrigin foi informado pelo contexto (ex.: Home),
     * evitando eventos sem área de origem nos apps que reutilizam o hub-nav sem bindar o input.
     * @param text rótulo do link (ex.: BOLSA, INVESTIMENTOS, APRENDA, AJUDA)
     */
    public trackHeaderNavLink(text: string) {
        if (!this.productAreaOrigin) {
            return;
        }
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events: {
                    'Product Area Origin': this.productAreaOrigin,
                    'Element': `Botão ${text}`,
                    'Group': 'Header',
                    'Text': text,
                    'Time Responsável': 'Sky',
                    ...(this.status && { 'Status': this.status }),
                    ...(this.scenario && { 'Scenario': this.scenario }),
                },
            },
        });
    }

    /**
     * Links para os itens do menu
     *
     * @param param
     */
    public onMenuLinkClick(param: string) {
        this.layerService.destroyOverlay("#overlay-navbar");
        this.openHrefLink(param);
    }

    /**
     * Redireciona para links externos ao sistemas Hub
     *
     * @param  {string} url
     */
    public openHrefLink(url: string) {
        if (
            this.externalRouter ||
            url.startsWith("/bolsa/") ||
            url.equals("/fundos/investir") ||
            url.equals("/produtos-renda-fixa/investir") ||
            new RegExp("/home").test(window.location.href)
        ) {
            if (window.location.href !== url) window.location.href = url;

            return;
        }

        if (url.equals("/home/cursos")) {
            this.store.dispatch({
                type: TrackingActions.trackEvents,
                payload: {
                    type: ActionEventsEnum.ELEMENT_CLICKED,
                    events: {
                        'Product Area Origin': "Aprenda",
                        'Time Responsável': "Sky",
                        'Element': "Menu Aprenda",
                        'Group': 'Menu Header',
                    }
                },
            });
        }

        this.router.navigateByUrl(url);
    }

    /**
     * Redireciona para link externo aos sistemas Hub
     *
     * @param  {string} link
     */
    public openExternalHrefLink = (link: string) => window.open(link);

    /**
     * Abre o menu lateral (mobile)
     */
    public showMenu() {
        this.dialogsService.showComponentAsAsidePanel(
            TrSideMenuComponent,
            true,
            this.externalRouter,
            false
        );
    }

    /**
     * Abre a modal de cadastro
     */
    public showRegistrationModal() {
        this.dialogsService.showComponnent(HubBaseRegistrationComponent);

        // Envio de dados para o Google Analytics
        this.store.dispatch({
            type: TrackingActions.trackFormEvent,
            payload: {
                type: FormsEventType.Modal,
                event: FormsEvents.exibidoPrimeiroPasso,
            },
        });

        // Envio de dados para o Segment
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: TrackOriginEnum.REGISTER_MODAL,
                events: {},
            },
        });
    }

    private get isMobile() {
        return window.innerWidth <= 767;
    }

    /**
     * Dtermina efeitos de scroll
     */
    private hasScrolled() {
        // Get position scroll top
        const top = Math.round(
            (window.pageYOffset || this.element.scrollTop) -
                (this.element.clientTop || 0)
        );

        if (!this.risesButNotGoDown && !this.notificationsMenuOpen) {
            // Add class 'navbar--up' when scrollTop ultrapass the menu for animate when scroll for top
            if (top > this.navbarHeight) {
                this.render.addClass(this.navBar.nativeElement, "get-up");
            } else if (top < this.navbarHeight) {
                this.render.removeClass(this.navBar.nativeElement, "get-up");
            }

            // Detect when scroll for top
            if (top < this.lastScroll && top > this.navbarHeight) {
                this.render.addClass(this.navBar.nativeElement, "get-down");
            }

            // Detect when scroll for down
            if (top === 0 || top > this.lastScroll) {
                this.render.removeClass(this.navBar.nativeElement, "get-down");
            }
        }

        this.lastScroll = top;
    }
}
